module.exports = __webpack_public_path__ + "img/John-Hancock_Carrier-Logos.0bd224a3.svg";